import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBibleBookModel, IBibleVerseModel } from '../../../models/bible.model';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
    providedIn: 'root',
})
export class BibleService extends BaseApiService {
    protected override endPoint = '/bibles';

    getBibleTypeAndChapters(): Observable<IBibleBookModel[]> {
        return this.http.get<IBibleBookModel[]>(`${this.fullPath}`);
    }

    getBibleVerses(chapterId: number): Observable<IBibleVerseModel[]> {
        const params = {
            page: 1,
            size: 200,
            chapterId,
        };
        return this.http.get<IBibleVerseModel[]>(`${this.fullPath}/verses`, { params });
    }

    searchBibleVerses(query: string): Observable<IBibleVerseModel[]> {
        const params = {
            bibleType: query,
        };
        return this.http.get<IBibleVerseModel[]>(`${this.apiServer}/searchBibleVerse`, { params });
    }
}
